// Effective unlock ladder for the signed-in user. The backend attaches
// `unlock_thresholds` to every Settings response (NORMAL, or the compressed
// BETA ladder when the owner flipped /admin → "Unlock pace" and the account
// is a beta tester). Falls back to NORMAL when the field is missing.
export const NORMAL_THRESHOLDS = {
    mode: "normal",
    stages: { warming: 7, friendly: 14, old_friend: 90 },
    milestones: { 7: 7, 14: 14, 30: 30, 100: 100, 365: 365 },
    sunglasses: 10,
};

export function thresholdsOf(settings) {
    return settings?.unlock_thresholds || NORMAL_THRESHOLDS;
}

// Day on which the canonical milestone (7/14/30/100/365) actually fires.
export function milestoneDay(settings, canonicalDay) {
    const t = thresholdsOf(settings);
    return Number(t.milestones?.[canonicalDay] ?? canonicalDay);
}

export function sunglassesTarget(settings) {
    return Number(thresholdsOf(settings).sunglasses ?? 10);
}

export function isBetaPace(settings) {
    return thresholdsOf(settings).mode === "beta";
}
